// состояния и классы "двойного" инпута с поиском
export const DOUBLE_SEARCH_STATUSES = {
  init: 0,
  edit: 1,
  done: 2,
  error: 3,
}
export const DOUBLE_SEARCH_CLASSES = ['', 'edit', 'done', 'error']
